import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/ui/PageWrapper';
import FadeUp from '../components/ui/FadeUp';
import CTASection from '../components/sections/CTASection';
import { useContent } from '../hooks/useContent';

export default function About() {
  const { content } = useContent();
  const a = content?.aboutFounder;
  const ap = content?.aboutPage;

  return (
    <PageWrapper>
      {/* Hero */}
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F 0%, #1A0F2E 100%)', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 70% 50%, rgba(232,135,26,0.06) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">{ap?.eyebrow ?? 'About the Founder'}</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}>
              {ap?.title ?? 'Engineer · Entrepreneur · Certified Vastu Consultant'}
            </h1>
            <div className="divider" />
            <p style={{ fontSize: 18, opacity: 0.7, maxWidth: 600, lineHeight: 1.8 }}>
              {ap?.subtitle ?? 'Combining technical expertise, business acumen, and authentic Vastu knowledge to create balanced environments.'}
            </p>
          </FadeUp>
        </div>
      </section>

      {/* Bio */}
      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          <div className="about-bio-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 64, alignItems: 'start' }}>
            <FadeUp>
              <div style={{ background: 'rgba(232,135,26,0.04)', border: '1px solid rgba(232,135,26,0.15)', borderRadius: 16, padding: 40, textAlign: 'center' }}>
                <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 22, color: '#E8871A', marginBottom: 8 }}>
                  {a?.name ?? 'The Founder'}
                </h2>
                <p style={{ fontSize: 13, opacity: 0.6, marginBottom: 24 }}>{a?.role ?? 'Certified Vastu Consultant'}</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {(a?.credentials ?? []).map((item: string, i: number) => (
                    <p key={i} style={{ fontSize: 13, opacity: 0.7, textAlign: 'left' }}>{item}</p>
                  ))}
                </div>
                <Link to="/contact" className="btn-primary" style={{ marginTop: 28, display: 'block', textAlign: 'center' }}>
                  Book Consultation
                </Link>
              </div>
            </FadeUp>

            <div>
              {(a?.bio ?? []).map((section: any, i: number) => (
                <FadeUp key={i} delay={i * 0.1}>
                  <div style={{ marginBottom: 36 }}>
                    <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, color: '#E8871A', marginBottom: 12 }}>
                      {section.title}
                    </h3>
                    <p style={{ fontSize: 15, lineHeight: 1.9, opacity: 0.7 }}>{section.text}</p>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* About the Company */}
      <section style={{ padding: '80px 0', background: '#1A0F2E' }}>
        <div className="container">
          <FadeUp style={{ textAlign: 'center', marginBottom: 60 }}>
            <p className="section-eyebrow">{ap?.company?.eyebrow ?? 'About the Company'}</p>
            <h2 className="section-title">{ap?.company?.title ?? 'The Perfect Vaastu'}</h2>
            <div className="divider" style={{ margin: '20px auto' }} />
          </FadeUp>
          <FadeUp>
            <div style={{ maxWidth: 800, margin: '0 auto' }}>
              {(ap?.company?.paragraphs ?? []).map((p: string, i: number) => (
                <p key={i} style={{ fontSize: 15, lineHeight: 1.9, opacity: 0.7, marginBottom: 24 }}>{p}</p>
              ))}
            </div>
          </FadeUp>
        </div>
      </section>

      <CTASection />

      <style>{`
        @media (max-width: 1024px) { .about-bio-grid { grid-template-columns: 1fr !important; gap: 40px !important; } }
        @media (max-width: 768px) { .about-bio-grid { grid-template-columns: 1fr !important; gap: 32px !important; } }
      `}</style>
    </PageWrapper>
  );
}
